import { useParams } from "react-router-dom";
import Content from "./StaffContent";

const ManageFirmContent = () => {
  const params = useParams<Record<string, string | undefined>>();
  return (
    <>
      <Content
        breadcrumb={{
          prevPage: "Home",
          currentPage: "Content",
        }}
        persistentFilter={({ memberFirms: { value: [params.id] } })}
        firmId={params.id}
      />
    </>
  );
};

export default ManageFirmContent;
